"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectDebitAccountNumberCollapseLabelWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_model_1 = require("@athena-portal/journey-model");
var InfoQuestionCollapseWrapperWithOptionalFields_1 = require("../../components/infoQuestion/InfoQuestionCollapseWrapperWithOptionalFields");
var DirectDebitAccountNumberCollapseLabelWidget = exports.DirectDebitAccountNumberCollapseLabelWidget = /** @class */ (function (_super) {
    __extends(DirectDebitAccountNumberCollapseLabelWidget, _super);
    function DirectDebitAccountNumberCollapseLabelWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnBlurEvent = function (event) {
            _this.props.onStateChange(_this.props.question.interactionField, _this.state.accountNumber);
            _super.prototype.handleOnBlurEvent.call(_this, event);
        };
        _this.handleAccountNumberChangeEvent = function (event) {
            var accountNumber = event.target.value.replace(/[^0-9.]/g, '');
            _this.setState({ accountNumber: accountNumber });
        };
        _this.state = {
            accountNumber: _this.bindFromField(props.question.interactionField),
            serviceError: false,
            classifier: ""
        };
        return _this;
    }
    DirectDebitAccountNumberCollapseLabelWidget.prototype.render = function () {
        var label = this.props.question.label ?
            React.createElement("label", null, this.props.question.label) : this.renderHtml(this.getSetting("labelHtml"));
        var additionalText = this.renderHtml(this.getSetting("additionalHtml"));
        return (React.createElement(InfoQuestionCollapseWrapperWithOptionalFields_1.InfoQuestionCollapseWrapperWithOptionalFields, { label: label, additionalText: additionalText, className: "account-number-input" },
            this.renderInputField(),
            this.renderValidationResult()));
    };
    DirectDebitAccountNumberCollapseLabelWidget.prototype.renderInputField = function () {
        return (React.createElement("div", { className: "d-flex direct-debit-account-number" },
            React.createElement("input", { type: "text", className: "form-control ".concat(this.getInputValidationClass()), id: this.props.question.name, placeholder: this.props.question.placeHolder, value: this.state.accountNumber, onChange: this.handleAccountNumberChangeEvent, onFocus: this.executeNativeEvent, onBlur: this.handleOnBlurEvent, maxLength: 8, onClick: this.executeNativeEvent, onDoubleClick: this.executeNativeEvent, readOnly: this.isReadOnly() })));
    };
    DirectDebitAccountNumberCollapseLabelWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "labelHtml", type: journey_model_1.TypeDescriptions.String },
            { name: "additionalHtml", type: journey_model_1.TypeDescriptions.String }
        ]),
        __metadata("design:paramtypes", [Object])
    ], DirectDebitAccountNumberCollapseLabelWidget);
    return DirectDebitAccountNumberCollapseLabelWidget;
}(plugin_journey_1.QuestionWidgetBase));
//# sourceMappingURL=DirectDebitAccountNumberCollapseLabelWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/directDebit/DirectDebitAccountNumberCollapseLabelWidget.js
// module id = 3487
// module chunks = 0